export default "<footer>\n    <span class=\"text-muted\">Pie de pagina debería venir aquí.</span>\n</footer>"